import * as React from 'react';
import { connect } from 'react-redux';
import { ProcessRefundForm } from './process-refund-form';
//import './process-refund-pane.scss';
import { InvoiceWithLineItems } from '@atlassian/cssxp-types-billing';
import { ErrorPanel } from '@css-xp/base/error-page';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { fetchInvoice } from '@atlassian/temp-proxies';
import { useState, useEffect } from 'react';

interface ReduxStateProps {
  invoice: InvoiceWithLineItems | null;
  isFetching: boolean;
  fetchError: Error | null;
}

interface ComponentProps {
  invoiceId: string;
}

export const ProcessRefundPane = ({ invoiceId }: ComponentProps) => {
  const [invoice, setInvoice] = useState<any>([]);
  const [isFetching, setisFetching] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    (async () => {
      const result = await fetchInvoice(invoiceId);
      if (result) {
        setInvoice(result);
        setisFetching(false);
      } else {
        setError({ message: 'Some Error Occured' } as Error);
      }
    })();
  }, [invoiceId]);

  if (isFetching) return <LoadingIndicator />;
  if (invoice === null) {
    return null;
  }
  return <ProcessRefundForm invoice={invoice} />;
};
